



















import contents from './contents';

export default {
  props: {
    id: String,
  },
  computed: {
    data() {
      return contents[this.id];
    },
  },
} as IView;
